/**
 * Unterkapitel-Aufteilung (Task F) — 1:1-Port von app.js splitInUnterkapitel:
 * Kapiteltext wird an <h3>-Grenzen in Abschnitte geteilt; <h2> (Kapiteltitel,
 * steht schon im Kopf) entfernt; Lead-Inhalt ohne eigenes <h3> wird in den
 * ersten echten Abschnitt gemergt. Keys = stabile Slugs aus der Überschrift
 * (Fallback Index, dedupliziert) — identisch zum Web, damit Fortschritts-Marken
 * (`sub-<key>`) zwischen Web und App synchron sind. (SOLL: Paritäts-Doku §3)
 */

export interface UkSegment {
  key: string;
  title: string;
  html: string;
}

export function ukSlug(s: string): string {
  return String(s || "")
    .toLowerCase()
    .replace(/<[^>]*>/g, "")
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
}

export function splitInUnterkapitel(html: string): UkSegment[] {
  if (!html) return [];
  let doc: Document;
  try {
    doc = new DOMParser().parseFromString(String(html), "text/html");
  } catch {
    return [{ key: "sub-0", title: "", html: String(html) }];
  }
  doc.querySelectorAll("h2").forEach((h) => h.remove());
  const nodes = Array.from(doc.body.childNodes);
  const segs: Array<{ title: string; html: string; key?: string }> = [];
  let cur: Node[] = [];
  let curTitle = "";
  const flush = () => {
    if (!cur.length) return;
    const d = document.createElement("div");
    cur.forEach((n) => d.appendChild(n.cloneNode(true)));
    const h = d.innerHTML.trim();
    if (h) segs.push({ title: curTitle, html: h });
    cur = [];
  };
  nodes.forEach((n) => {
    if (n.nodeType === 1 && (n as Element).tagName.toLowerCase() === "h3") {
      flush();
      curTitle = (n.textContent || "").trim();
    }
    cur.push(n);
  });
  flush();
  // Lead ohne eigene <h3> in den ersten echten Abschnitt mergen (kein dünnes Intro-Segment).
  if (segs.length > 1 && !/<h3[\s>]/i.test(segs[0].html)) {
    segs[1].html = segs[0].html + segs[1].html;
    segs.shift();
  }
  if (!segs.length) segs.push({ title: "", html: (doc.body.innerHTML || "").trim() || String(html) });
  const seen: Record<string, number> = {};
  segs.forEach((s, i) => {
    let base = ukSlug(s.title) || `sub-${i}`;
    if (seen[base] != null) {
      seen[base]++;
      base = `${base}-${seen[base]}`;
    } else {
      seen[base] = 0;
    }
    s.key = base;
  });
  return segs as UkSegment[];
}
